// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  organizationId: __t.string().name("organization_id"),
  name: __t.string(),
  description: __t.option(__t.string()),
  icon: __t.option(__t.string()),
  category: __t.option(__t.string()),
  conditions: __t.string(),
  author: __t.string(),
  rejectPlaybookId: __t.option(__t.string()).name("reject_playbook_id"),
  priority: __t.i32(),
  isActive: __t.bool().name("is_active"),
  isPromotional: __t.bool().name("is_promotional"),
  createdAt: __t.option(__t.timestamp()).name("created_at"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
});
